module.exports = __webpack_public_path__ + "img/weather45.a8074636.png";